export default "__VITE_ASSET__0oW8GNN7__"